const getEnv = () => {
  // eslint-disable-next-line no-undef
  const branchSlug = process.env.CI_COMMIT_REF_SLUG;
  if (!branchSlug) {
    return 'local';
  }

  switch (branchSlug) {
    case 'master':
      return 'production';
    case 'staging':
      return 'staging';
    default:
      return 'develop';
  }
};

// eslint-disable-next-line no-undef
module.exports = { getEnv };
